import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import Checkbox from '../primitives/Checkbox/Checkbox';
import Button from '../primitives/Button/Button';
import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';
import { VAULT_TERMS_AND_CONDITIONS_DO_NOT_SHOW_AGAIN_KEY } from 'src/constants/vaults/misc';
import { useState } from 'react';
import useModal from 'src/components/Modals/hooks/useModal';
import BaseModal from '../primitives/BaseModal/BaseModal';
import Link from '../primitives/Link/Link';
import { VELOCITY_DOCS_URL } from 'src/constants/constants';

export interface VaultTermsDisclaimerModalProps {
	depositCallback: () => Promise<void>;
}

export default function VaultTermsDisclaimerModal({
	depositCallback,
}: VaultTermsDisclaimerModalProps) {
	const setVelocityStore = useVelocityStore((s) => s.set);
	const hasSelectedDoNotShowAgain = useVelocityStore(
		(s) => s[VAULT_TERMS_AND_CONDITIONS_DO_NOT_SHOW_AGAIN_KEY]
	);
	const { hide } = useModal();

	const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
	const [_1, setAgreedVaultTermsDoNotShowAgain] = useSyncLocalStorage(
		VAULT_TERMS_AND_CONDITIONS_DO_NOT_SHOW_AGAIN_KEY
	);

	const handleAgreeTerms = () => {
		if (!hasAcceptedTerms) return;

		setAgreedVaultTermsDoNotShowAgain(hasSelectedDoNotShowAgain);
		hide();
		depositCallback?.();
	};

	return (
		<BaseModal.Container onClose={hide}>
			<BaseModal.Title onClose={hide}>Disclaimer</BaseModal.Title>
			<BaseModal.Body>
				<span className="text-text-secondary">
					Vaults are experimental. Your use of this interface or any third party
					linked interface is at your sole risk. Please ensure you understand
					any platforms or protocols underlying these Vaults.
					<br />
					<br />
					By continuing, you agree and acknowledge{' '}
					<Link
						href={`${VELOCITY_DOCS_URL}/legal-and-regulations/terms-of-use`}
						openInNewTab
					>
						Velocity Terms
					</Link>{' '}
					together with any further terms set out on this interface or linked
					interfaces. You further agree that you accept all risks, including the
					possible loss of all funds. Velocity will not be liable for any
					losses, claims, damages, errs, disruptions, or delays, inter alia.
				</span>
				<Checkbox.Default
					id="vault-terms-disclaimer-agree-terms"
					checked={hasAcceptedTerms}
					onCheckedChange={() => setHasAcceptedTerms((prev) => !prev)}
					label="I have read, understood, and agree to the terms above"
				/>
				<Checkbox.Default
					id="vault-terms-disclaimer-do-not-show-again"
					checked={hasSelectedDoNotShowAgain}
					onCheckedChange={() =>
						setVelocityStore((s) => {
							s[VAULT_TERMS_AND_CONDITIONS_DO_NOT_SHOW_AGAIN_KEY] =
								!hasSelectedDoNotShowAgain;
						})
					}
					label="Do not show this message again"
				/>
			</BaseModal.Body>
			<BaseModal.Footer>
				<Button
					size="lg"
					variant="primary"
					className="w-full"
					disabled={!hasAcceptedTerms}
					onClick={handleAgreeTerms}
				>
					Confirm
				</Button>
			</BaseModal.Footer>
		</BaseModal.Container>
	);
}
